export type ChatbotFeedbackAction = "like" | "dislike";

export const CHATBOT_FEEDBACK_ENDPOINT =
  "https://script.google.com/macros/s/AKfycbyteCGUHhM9R7QYhBBdTo-lp7j8gZ7KnMohU6wixKWig_lMzbpC2gvr2JmMsUxjQnI/exec";

export function createChatbotFeedbackUrl(action: ChatbotFeedbackAction, messageId: string) {
  const url = new URL(CHATBOT_FEEDBACK_ENDPOINT);
  url.searchParams.set("action", action);
  url.searchParams.set("uuid", messageId);
  return url;
}

export async function recordChatbotFeedback(action: ChatbotFeedbackAction, messageId: string) {
  const url = createChatbotFeedbackUrl(action, messageId);
  const startedAt = Date.now();

  try {
    await fetch(url, { mode: "no-cors" });
  } catch (error) {
    console.error(
      "[chatbot:feedback]",
      JSON.stringify({
        event: "feedback.request.error",
        action,
        messageId,
        url: url.toString(),
        durationMs: Date.now() - startedAt,
        error:
          error instanceof Error
            ? {
                name: error.name,
                message: error.message,
                stack: error.stack,
              }
            : { message: String(error) },
      })
    );
    throw error;
  }
}
